import React, { useState, useEffect } from 'react';
import './PromiseSection.css';

const PromiseSection = () => {
    const promises = [
        {
            id: 1,
            icon: '🚚', // We can replace this with an SVG or Image later
            title: 'ON-TIME DELIVERY',
            description: 'Because no one likes late surprises.'
        },
        {
            id: 2,
            icon: '🎨',
            title: '1000+ DESIGNS',
            description: 'Pick from our huge collection or customize your own.'
        },
        {
            id: 3,
            icon: '🧁',
            title: 'BAKED FRESH',
            description: 'Every cake is baked fresh only after you order.'
        }
    ];

    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((current) => (current + 1) % promises.length);
        }, 3000); // Change slide every 3 seconds

        return () => clearInterval(interval);
    }, []);

    return (
        <section className="promise-section">
            <div className="container">
                <div className="promise-header">
                    <h2 className="promise-title">Our Promise</h2>
                    <p className="promise-subtitle">There's no secret spell—only honest, hard work!</p>
                </div>

                <div className="promise-slider">
                    <div className="promise-slide fade-in" key={activeIndex}>
                        <div className="promise-icon-container">
                            <span className="promise-icon">{promises[activeIndex].icon}</span>
                        </div>
                        <h3 className="promise-item-title">{promises[activeIndex].title}</h3>
                        <p className="promise-item-desc">{promises[activeIndex].description}</p>
                    </div>
                </div>

                <div className="promise-dots">
                    {promises.map((_, index) => (
                        <span 
                            key={index} 
                            className={`promise-dot ${index === activeIndex ? 'active' : ''}`}
                            onClick={() => setActiveIndex(index)}
                        ></span>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PromiseSection;
